export const formatDate = (date, format) => {
  format = format.replace(/yyyy/g, date.getFullYear());
  format = format.replace(/MM/g, ("0" + (date.getMonth() + 1)).slice(-2));
  format = format.replace(/dd/g, ("0" + date.getDate()).slice(-2));
  format = format.replace(/HH/g, ("0" + date.getHours()).slice(-2));
  format = format.replace(/mm/g, ("0" + date.getMinutes()).slice(-2));
  format = format.replace(/ss/g, ("0" + date.getSeconds()).slice(-2));
  format = format.replace(/SSS/g, ("00" + date.getMilliseconds()).slice(-3));

  // 曜日のフォーマットを追加
  const weekdays = ["日", "月", "火", "水", "木", "金", "土"];
  format = format.replace(/E/g, weekdays[date.getDay()]);

  return format;
};

export const formatDateJaFull = (date) => {
  return formatDate(date, "yyyy年MM月dd日HH:mm:ss");
};

// 曜日付きの日付フォーマット関数を追加
export const formatDateJaFullWithWeekday = (date) => {
  return formatDate(date, "yyyy年MM月dd日(E)HH:mm:ss");
};

// 時間なしの曜日付き日付フォーマット関数を追加
export const formatDateJaWithWeekday = (date) => {
  return formatDate(date, "yyyy年MM月dd日(E)");
};

// 時間付きの曜日付き日付フォーマット関数を追加
export const formatDateTimeJaWithWeekday = (date) => {
  return formatDate(date, "yyyy年MM月dd日(E)HH:mm");
};
